window.GastronomyLaborAPI = new (function () {
    'use strict';

    var self = this;
    var _protected = BaseAPI.call(self);

    self.FORECASTING_TYPES = {
        DT_SELF_PACK: {value: 'DT_SELF_PACK', label: $filter("translate")('DT1 Self Pack')},
        DT_SELF_PACK_WITH_LOW_OR_NO_DELIVERY: {
            value: 'DT_SELF_PACK_WITH_LOW_OR_NO_DELIVERY',
            label: $filter("translate")('DT2 Self Pack with no or Low Delivery')
        },
        DT_FUSION_PACK: {value: 'DT_FUSION_PACK', label: $filter("translate")('DT3 Fusion Pack')},
        IL_SELF_PACK: {value: 'IL_SELF_PACK', label: $filter("translate")('IL1 Self Pack')},
        IL_FUSION_PACK: {value: 'IL_FUSION_PACK', label: $filter("translate")('IL2 Fusion')}
    };

    _protected.setApiUrl(publicConfiguration['GastronomyLabor']);

    self.getForecastingType = function (brandId) {
        if (!brandId || brandId === -1 || isNaN(brandId)) {
            throw 'This api required brandId ' + brandId;
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.putForecastingType = function (brandId, payload) {
        if (!brandId || brandId === -1 || isNaN(brandId)) {
            throw 'This api required brandId ' + brandId;
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getFixedHoursSettings = function (brandId) {
        if (!brandId || brandId === -1 || isNaN(brandId)) {
            throw 'This api required brandId ' + brandId;
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/fixed_hours', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.putFixedHoursSettings = function (brandId, payload) {
        if (!brandId || brandId === -1 || isNaN(brandId)) {
            throw 'This api required brandId ' + brandId;
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/fixed_hours', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getStations = function (brandId) {
        if (!brandId || brandId === -1 || isNaN(brandId)) {
            throw 'This api required brandId ' + brandId;
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/stations/mapping', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getBrandLaborForecast = function (brandId, startDate, endDate) {
        if (!brandId || brandId === -1 || isNaN(brandId)) {
            throw 'This api required brandId ' + brandId;
        }

        var deferred = $q.defer();

        var params = {
            start_week_date: startDate,
            end_week_date: endDate,
            mode: 'BASIC'
        };

        _protected.request('brands/' + brandId + '/labor_forecasts', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.generateLaborForecast = function (brandId, generateData) {
        if (!brandId || brandId === -1 || isNaN(brandId)) {
            throw 'This api required brandId ' + brandId;
        }

        var deferred = $q.defer();

        var params = {
            start_date: generateData.start_date,
            adjustment_ids: generateData.adjustment_ids
        };

        _protected.request('brands/' + brandId + '/labor_forecasts/generate', 'POST', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getLaborForecastForWeek = function (brandId, startDate) {
        if (!brandId || brandId === -1 || isNaN(brandId)) {
            throw 'This api required brandId ' + brandId;
        }

        var deferred = $q.defer();

        var params = {
            start_date: startDate
        };

        _protected.request('brands/' + brandId + '/labor_forecasts/week', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createNewAdjustment = function (brandId, adjustment) {
        if (!brandId || brandId === -1 || isNaN(brandId)) {
            throw 'This api required brandId ' + brandId;
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/labor_forecasts/adjustments', 'POST', adjustment)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateAdjustment = function (brandId, adjustment) {
        if (!brandId || brandId === -1 || isNaN(brandId)) {
            throw 'This api required brandId ' + brandId;
        }

        if (!adjustment.id) {
            throw 'This api required adjustmentId ' + !adjustment.id;
        }

        var deferred = $q.defer();


        _protected.request('brands/' + brandId + '/labor_forecasts/adjustments/' + adjustment.id, 'PUT', adjustment)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandAdjustments = function (brandId) {
        if (!brandId || brandId === -1 || isNaN(brandId)) {
            throw 'This api required brandId ' + brandId;
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/labor_forecasts/adjustments', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteAdjustment = function (brandId, adjustmentId) {
        if (!brandId || brandId === -1 || isNaN(brandId)) {
            throw 'This api required brandId ' + brandId;
        }

        if (!adjustmentId) {
            throw 'This api required adjustmentId ' + adjustmentId;
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/labor_forecasts/adjustments/' + adjustmentId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.handleAdjustmentsManagementError = function (err) {
        if (err.status === 403) {
            var massage = $filter("translate")("Something went wrong") + '! ' + $filter("translate")("Please try again");

            if (err.data && err.data.errors && err.data.errors[0]) {
                switch (err.data.errors[0].code) {
                    case "ADJUSTMENT_IS_ALREADY_APPLIED_TO_WEEK":
                        massage = $filter("translate")("Adjustment is in use") + ". " +  $filter("translate")("You can’t edit or delete this adjustment");
                        break;
                }
            }

            hAlert({
                title: $filter("translate")("Error Managing Adjustment!"),
                text: massage,
                custom_class: 'rejection-templates-error-alert',
                button: {
                    text: $filter("translate")("Okay")
                }
            });

        } else {
            console.error(err);
        }
    };
});